import React, { useState, useEffect } from "react";
import axiosInstance from '../../axiosInstance';
import { useTranslation } from 'react-i18next';
import Typography from 'apollo-react/components/Typography';

import Grid from 'apollo-react/components/Grid';
// import Paper from 'apollo-react/components/Paper';

import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';

import IconButton from 'apollo-react/components/IconButton';
import Mailbox from 'apollo-react-icons/Mailbox';
import AlertTriangle from 'apollo-react-icons/AlertTriangle';
import User2 from 'apollo-react-icons/User2';
import StatusCheck2 from 'apollo-react-icons/StatusCheck2';

import subProject from "../../assets/images/charts-sub_projects.png";
import categories from "../../assets/images/charts-categories.png";
import teamUtil from "../../assets/images/charts-team_utilization.png";


import { getCurrentUser } from './services/authService';

const gridStyle = {
  padding: 0,
  margin: '10px',
  border: '0px'
};

const cardStyle = {
  padding: '0px 14px 15px 14px',
  borderRadius: '17px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #e6e6e6',
};

const activeCardStyle = {
  padding: '0px 14px 15px 14px',
  borderRadius: '17px',
  backgroundColor: '#423F3F',
};

const cardHeaderStyle = {
  paddingBottom: '4px'
};

const activeTasksStyle = {
  color: '#FFFFFF'
};

const closedTasksStyle = {
  color: '#4CAF50'
};

const safetyReportStyle = {
  color: '#fc2112'
};

const cardHeaderIconStyle = {
  fontSize: '36px'
};

const bodyTypoStyle = {
  fontSize: '24px', 
  fontWeight: 'bold'
};

const imgHeightStyle = {
  width: '100%'
};

const imgCustomHeightStyle = {
  width: '90%',
  float: 'right',
};

const imageContainerHeightStyle = {
  height: '285.81px',
};



const Home = () => {
  const [t] = useTranslation();
    const [newRequests, setNewRequests] = useState(0);
    const [activeRequests, setActiveRequests] = useState(0);
    const [closedRequests, setClosedRequests] = useState(0);

    useEffect(() => {
      const fetchProfileData = async () => {
        try {
          
        } catch (error) {
          console.error("Error fetching profile data:", error);
        }
      };
  
      fetchProfileData();
    }, []);

    useEffect(() => {
      const fetchRequests = async () => {
        try {

          const getUser = await getCurrentUser();
          if (!getUser) return;
          
          console.log("Fetching requests for user type:", getUser.end_users_category?.name);
          if(getUser.end_users_category?.name === 'Committee') {
            
            const response = await axiosInstance.get(
              `${process.env.REACT_APP_SERVER_URL}/api/committee-reviews/active/committees`,
              { withCredentials: true }
            );

            setNewRequests((response.data || []).length);
            setActiveRequests(0);
            setClosedRequests(0);

          } else {
            const response = await axiosInstance.get(
              `${process.env.REACT_APP_SERVER_URL}/api/requests-progress/user/requests`,
              { withCredentials: true }
            );
    
            setNewRequests((response?.data.submittedRequestsProgress || []).length);
            setActiveRequests((response?.data.activeRequestsProgress || []).length + (response?.data.irbApprovedSubmittedRequestsProgress || []).length + (response?.data.raApprovedSubmittedRequestsProgress || []).length + (response?.data.continueOnRequestProgress || []).length);
            setClosedRequests((response?.data.completedStudiesReviewRequestProgress || []).length + (response?.data.irbRejectedSubmittedRequestsProgress || []).length + (response?.data.raRejectedSubmittedRequestsProgress || []).length);

          }
          
        } catch (err) {
          console.error("Error fetching requests:", err);
        }
      };
  
      fetchRequests();
    }, []);

  return (
    <div className="content">
        <Grid container spacing={2}>
          <Grid item xs={12}  md={3}>
            <div style={gridStyle}>
              <Card tabIndex={0} interactive style={activeCardStyle}>
                  <CardHeader title="Active Tasks" style={cardHeaderStyle} titleTypographyProps={{ style: activeTasksStyle }} action={
                      <IconButton aria-label="settings" style={{...cardHeaderIconStyle, color: activeTasksStyle.color }} disabled>
                        <Mailbox />
                      </IconButton>
                    } />
                  <CardContent>
                    <Typography style={{...bodyTypoStyle, color: activeTasksStyle.color }}>
                      {activeRequests}
                    </Typography>
                  </CardContent>
              </Card>
            </div>
          </Grid>
          <Grid item xs={12}  md={3}>
            <div style={gridStyle}>
              <Card tabIndex={0} interactive style={cardStyle}>
                  <CardHeader title="Closed Tasks" style={cardHeaderStyle} titleTypographyProps={{ style: closedTasksStyle }} action={
                      <IconButton disabled aria-label="settings" style={{ ...cardHeaderIconStyle, color: closedTasksStyle.color }}>
                        <StatusCheck2 />
                      </IconButton>
                    } />
                  <CardContent>
                    <Typography style={bodyTypoStyle}>
                      {closedRequests}
                    </Typography>
                  </CardContent>
              </Card>
            </div>
          </Grid>
          <Grid item xs={12}  md={3}>
            <div style={gridStyle}>
              <Card tabIndex={0} interactive style={cardStyle}>
                  <CardHeader title="New Requests" style={cardHeaderStyle} action={
                      <IconButton aria-label="settings" style={cardHeaderIconStyle} disabled>
                        <User2 />
                      </IconButton>
                    } />
                  <CardContent>
                    <Typography style={bodyTypoStyle}>
                      {newRequests}
                    </Typography>
                  </CardContent>
              </Card>
            </div>
          </Grid>
          <Grid item xs={12}  md={3}>
            <div style={gridStyle}>
              <Card tabIndex={0} interactive style={cardStyle}>
                  <CardHeader title="Safety Reports" style={cardHeaderStyle} titleTypographyProps={{ style: safetyReportStyle }} action={
                      <IconButton aria-label="settings" style={{...cardHeaderIconStyle, color: safetyReportStyle.color }} disabled>
                        <AlertTriangle />
                      </IconButton>
                    } />
                  <CardContent>
                    <Typography style={bodyTypoStyle}>
                      2
                    </Typography>
                  </CardContent>
              </Card>
            </div>
          </Grid>
          <Grid item xs={12}  md={8}>
            <div style={gridStyle}>
              <img src={subProject} alt="Placeholder" style={{...imgHeightStyle, ...imageContainerHeightStyle}} />
            </div>
          </Grid>
          <Grid item xs={12}  md={4}>
            <div style={gridStyle}>
              <img src={categories} alt="Placeholder" style={{...imgCustomHeightStyle, ...imageContainerHeightStyle}} />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={gridStyle}>
              <img src={teamUtil} alt="Placeholder" style={{ width: '100%' }} />
            </div>
          </Grid>
        </Grid>
    </div>
  );
};

export default Home;